import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'm14.539 13.465-3.86-3.85a5.23 5.23 0 1 0-4.19 2.1 5.143 5.143 0 0 0 3.12-1.05l3.87 3.86a.71.71 0 0 0 .53.22.742.742 0 0 0 .53-.22.754.754 0 0 0 0-1.06Zm-8.05-3.25a3.735 3.735 0 1 1 3.73-3.73 3.73 3.73 0 0 1-3.73 3.73Zm2.75-3.73a.755.755 0 0 1-.75.75h-1.25v1.25a.75.75 0 0 1-1.5 0v-1.25h-1.25a.75.75 0 0 1 0-1.5h1.25v-1.25a.75.75 0 1 1 1.5 0v1.25h1.25a.749.749 0 0 1 .75.75Z';
const draw24px = 'M20.319,19.256l-5.33-5.33a6.649,6.649,0,0,0,1.48-4.2,6.75,6.75,0,1,0-6.75,6.75,6.665,6.665,0,0,0,4.21-1.49l5.33,5.33a.71.71,0,0,0,.53.22.742.742,0,0,0,.53-.22A.754.754,0,0,0,20.319,19.256Zm-10.6-4.28a5.25,5.25,0,1,1,5.25-5.25A5.262,5.262,0,0,1,9.719,14.976Zm3.75-5.25a.749.749,0,0,1-.75.75h-2.25v2.25a.75.75,0,0,1-1.5,0v-2.25H6.719a.75.75,0,1,1,0-1.5h2.25V6.726a.75.75,0,0,1,1.5,0v2.25h2.25A.743.743,0,0,1,13.469,9.726Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const MagnifyingGlassPlusIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'magnifyingGlassPlus'));
MagnifyingGlassPlusIcon.displayName = 'MagnifyingGlassPlusIcon';
MagnifyingGlassPlusIcon.propTypes = Icon.propTypes;
MagnifyingGlassPlusIcon.renderIcon = props => /*#__PURE__*/React.createElement(MagnifyingGlassPlusIcon, props);
export default MagnifyingGlassPlusIcon;
//# sourceMappingURL=MagnifyingGlassPlusIcon.js.map